// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateArgentineZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || !zipcodeValue.trim())
    return { id: 'empty' };
  else if (!/^[0-9]{4}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
